import { Signal } from "signals";
import Components from "slotworks/components/components";
import PromptContent from "slotworks/components/prompt/prompt-content";
import { ToggleEvent } from "slotworks/graphics/elements/flexi-toggle";
import Layers from "slotworks/graphics/layers/layers";
import { Services } from "slotworks/services/services";
import Contract from "slotworks/utils/contracts/contract";
import Logger from "slotworks/utils/logger";

export default class AlertComponent {

    public rememberedChoices: Map<string, boolean> = new Map<string, boolean>();
    public onFatal: Signal = new Signal();

    protected fatal: boolean = false;

    public info(messageId: string): Contract<void> {
        gameWrapper.gamePopupShown();
        if (this.fatal) {
            return Contract.never();
        }

        let message = this.getMessage(messageId);

        if (message === undefined || message === "" || !message) {
            message = Services.translations.get("General Error");
        }

        const prompt = new PromptContent(["info", "error"], Infinity, Layers.Alerts);
        prompt.setText("body", message);
        prompt.addContinueButton();

        return new Contract<void>((resolve) => {
            Components.prompt.showPrompt(prompt).then(() => {
                gameWrapper.gamePopupHidden();
                resolve(null);
            });
        });
    }

    /**
     * @param messageId {string}
     * @param uid {string} Unique ID to use to save preference of don't show again checkbox
     */
    public confirm(messageId: string, uid?: string): Contract<boolean> {
        gameWrapper.gamePopupShown();
        if (this.fatal) {
            return Contract.never();
        }

        return new Contract<boolean>((resolve) => {
            const confirmUID = "prompt_" + (uid || messageId);

            const rememberedChoice = this.rememberedChoices.get(confirmUID);

            if (rememberedChoice) {
                resolve(false);
                return;
            }

            let message = this.getMessage(messageId);

            if (message === undefined || message === "" || !message) {
                message = Services.translations.get("General Error");
            }

            const prompt = new PromptContent(["confirm", "yes_no"], Infinity, Layers.Alerts);
            prompt.addContinueButton();
            prompt.addButton("no", () => {
                prompt.hide().execute();
                resolve(false);
            });
            prompt.setText("body", message);
            prompt.addContinueButton();

            Components.prompt.showPrompt(prompt).then(() => {
                gameWrapper.gamePopupHidden();
                prompt.hide().execute();
                resolve(true);
            });

            const checkbox = Layers.Alerts.getFlexiToggle("checkbox");
            if (checkbox) {
                checkbox.setValue(false);
                checkbox.on(ToggleEvent.CHANGE, () => {
                    this.rememberedChoices.set(confirmUID, checkbox.getValue());
                });
            }
        });

    }

    public error(messageId: string, fatal: boolean = false): Contract<void> {
        gameWrapper.gamePopupShown();
        if (this.fatal) {
            return Contract.never();
        }

        if (fatal) {
            this.fatal = true;
            this.onFatal.dispatch();
        }

        let message = this.getMessage(messageId);

        if (message === undefined || message === "" || !message) {
            message = Services.translations.get("General Error");
        }

        if (!Layers.Alerts.hasAnyScene(["info", "error"])) {
            Logger.error(new Error().stack);
        }

        const prompt = new PromptContent(["info", "error"], Infinity, Layers.Alerts);
        prompt.setText("body", message);
        prompt.addContinueButton();

        return new Contract<void>((resolve) => {
            Components.prompt.showPrompt(prompt).then(() => {
                gameWrapper.gamePopupHidden();
                if (fatal) {
                    location.reload();
                }

                resolve(null);
            });
        });
    }

    public recover(messageID?: string): Contract<void> {
        return this.info(messageID ? messageID : "rec.spi");
    }

    protected getMessage(messageId: string) {
        let message;

        try {
            message = Services.translations.get(messageId);
        } catch (e) {
            message = messageId;
        }

        return message;
    }
}
